/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import {reactive} from "vue";
import {AuthStateEnum} from "@shared/AuthStateEnum.js";

export default {
	namespaced: false,
	state: reactive({
		isTokenSet: false,
		authState: AuthStateEnum.STARTING,
		authError: null,
		currentUser: null,
		coachProfile: null,
		ownerProfile: null,
		ownerSubscription: null,
		embeddedCoachProfile: null,
		userProfile: {},
		userSubscription: {},
		isQwoachEmbedded: false,
		embeddedUid: null,
		isSidebarOpen: true,
	}),
	getters: {
		isTokenSet: state => state.isTokenSet,
	},
	actions: {
		clearData({commit}){
			console.log("store.clearData")
			commit('setCurrentUser', null)
			commit('setOwnerProfile', null)
			commit('setOwnerSubscription', null)
			commit('setUserProfile', {})
			commit('setCoachProfile', {})
			commit('setUserSubscription', {})
		}
	},
	mutations: {
		setAuthStatus(state, {status, error}){
			state.authState = status
			state.authError = error
			state.isTokenSet = status === AuthStateEnum.READY || status === AuthStateEnum.SIGNED_OUT
		},
		setAccountContext(state, context){
			Object.assign(state, context)
		},
		setIsTokenSet(state, val){
			console.log("store.setIsTokenSet: val = ", val)
			state.isTokenSet = val
		},
		setCurrentUser(state, val){
			console.log("store.setCurrentUser: val = ", val)
			state.currentUser = val
		},
		setUserProfile(state, val){
			console.log("store.setUserProfile: val = ", val)
			state.userProfile = val
		},
		setOwnerProfile(state, val){
			console.log("store.setOwnerProfile: val = ", val)
			state.ownerProfile = val
		},
		setOwnerSubscription(state, val){
			console.log("store.setOwnerSubscription: val = ", val)
			state.ownerSubscription = val
		},
		setCoachProfile(state, val){
			console.log("store.setCoachProfile: val = ", val)
			state.coachProfile = val
		},
		setEmbeddedCoachProfile(state, val){
			console.log("store.setEmbeddedCoachProfile: val = ", val)
			state.embeddedCoachProfile = val
		},
		setUserSubscription(state, val){
			console.log("store.setUserSubscription: val = ", val)
			state.userSubscription = val
		},
		setIsQwoachEmbedded(state, val){
			console.log("store.isQwoachEmbedded: val = ", val)
			state.isQwoachEmbedded = val
		},
		setEmbeddedUid(state, val){
			console.log("store.embeddedUid: val = ", val)
			state.embeddedUid = val
		},
		setIsSidebarOpen(state, val){
			console.log("store.setIsSidebarOpen: val = ", val)
			state.isSidebarOpen = val
		},


	}
}
